<template>
  <div class="mic-control-container">
    <p class="accent">
      <slot />
    </p>

    <Gauge
      v-model="gaugeValueProxy"
      :disabled="false"
      :min="GAUGE_SETTINGS.valueMin"
      :max="GAUGE_SETTINGS.valueMax"
      :increment="GAUGE_SETTINGS.valueIncrement"
      :min-label="GAUGE_SETTINGS.labelMin"
      :max-label="GAUGE_SETTINGS.labelMax"
    />
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import Gauge from '@/components/shared/base/Gauge.vue';
import { useUserStore } from '@/stores/user';

const props = withDefaults(
  defineProps<{
    isGlobal?: boolean;
    gaugeSettingGlobal: string;
  }>(),
  { isGlobal: false }
);

const { t } = useI18n();
const userStore = useUserStore();

const modelValue = defineModel<number | null>();

const GAUGE_SETTINGS = computed(() => {
  const mapperPropGauge = {
    textSizeMultiplier: {
      valueMin: 0.875,
      valueMax: 2,
      valueIncrement: 0.125,
      labelMin: '0.875',
      labelMax: '2',
    },
    subtitleLineHeight: {
      valueMin: 1.3,
      valueMax: 2,
      valueIncrement: 0.1,
      labelMin: '1.3',
      labelMax: '2.0',
    },
    subtitleLineCount: {
      valueMin: 2,
      valueMax: 4,
      valueIncrement: 1,
      labelMin: t('subtitle_line_count_2'),
      labelMax: t('subtitle_line_count_4'),
    },
    subtitleOpacity: {
      valueMin: 0,
      valueMax: 1,
      valueIncrement: 0.1,
      labelMin: '0',
      labelMax: '1',
    },
    subtitleLocationY: {
      valueMin: 0,
      valueMax: 50,
      valueIncrement: 1,
      labelMin: '0%',
      labelMax: '50%',
    },
    screenScrollHeight: {
      valueMin: 20,
      valueMax: 60,
      valueIncrement: 10,
      labelMin: '20%',
      labelMax: '60%',
    },
  };
  return mapperPropGauge[props.gaugeSettingGlobal];
});

const gaugeValueProxy = computed<number>({
  get() {
    return modelValue.value ?? userStore.userPreferences[props.gaugeSettingGlobal];
  },
  set(value) {
    if (props.isGlobal) {
      userStore.userPreferences[props.gaugeSettingGlobal] = value;
    }

    modelValue.value = value;
  },
});
</script>

<style scoped lang="scss">
.mic-control-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: fit-content;
  gap: 0.5rem;
  color: var(--font-default);
  // 26.1.26
  .accent {
    font-size: 0.75rem;
  }
}
</style>
